import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ServiceOption } from "../constants/services";
import blueIconRow from "assets/img/icons/blue-Icon-row.svg";

interface ProjectAdditionalServicesProps {
  availableServices: ServiceOption[];
  translationType: string;
}

export default function ProjectAdditionalServices({
  availableServices,
  translationType,
}: ProjectAdditionalServicesProps) {
  const navigate = useNavigate();

  const handleStartOrder = (service: ServiceOption) => {
    navigate("/customer/main", {
      state: {
        preselectedType: translationType,
        preselectedService: service.key,
        step: 3,
      },
    });
  };

  return (
    <Box>
      {availableServices.length > 0 && (
        <Box
          mb="16px"
          bg="#F5F7FA"
          p="24px"
          borderRadius="12px"
          border="1px solid #E6ECF3"
        >
          <Heading fontSize="16px" fontWeight="600" mb="16px" color="#0B0E10">
            Additional services
          </Heading>

          {availableServices.map((service, index) => (
            <Box
              key={service.id}
              mb={index < availableServices.length - 1 ? "16px" : "0"}
            >
              <Box
                h="145px"
                bg="#F0FFF4"
                p="16px"
                borderRadius="16px"
                border="2px dashed #68D391"
              >
                <Flex direction="column">
                  <Box mb="12px">
                    <Text
                      fontSize="16px"
                      fontWeight="600"
                      mb="4px"
                      color="#0B0E10"
                    >
                      {service.label}
                    </Text>
                    <Text
                      fontSize="14px"
                      fontWeight="400"
                      color="#505E70"
                      lineHeight="1.5"
                    >
                      {service.description}
                    </Text>
                  </Box>
                  <Button
                    h="32px"
                    w="120px"
                    bg="white"
                    color="#2F80ED"
                    px="16px"
                    borderRadius="25px"
                    fontSize="14px"
                    fontWeight="500"
                    border="1px solid #2563EB"
                    _hover={{ bg: "#EBF8FF" }}
                    onClick={() => handleStartOrder(service)}
                  >
                    Start order
                  </Button>
                </Flex>
              </Box>
            </Box>
          ))}
        </Box>
      )}

      <Box bg="#F5F7FA" p="24px" borderRadius="16px" border="1px solid #E6ECF3">
        <Heading fontSize="16px" fontWeight="600" mb="16px" color="#0B0E10">
          Need something else?
        </Heading>

        <Link
          display="flex"
          alignItems="center"
          gap="8px"
          color="#3A7BFF"
          fontSize="16px"
          fontWeight="600"
          mb="16px"
          _hover={{ textDecoration: "underline" }}
          onClick={() => navigate("/customer/support")}
        >
          Request support <Image src={blueIconRow} alt="arrow" />
        </Link>

        <Link
          display="flex"
          alignItems="center"
          gap="8px"
          color="#3A7BFF"
          fontSize="16px"
          fontWeight="600"
          _hover={{ textDecoration: "underline" }}
          onClick={() => navigate("/customer/main")}
        >
          Start a new order <Image src={blueIconRow} alt="arrow" />
        </Link>
      </Box>
    </Box>
  );
}
